<main>
  <div class="container-fluid header" *ngIf="customerCareDetails">
    <div class="row">
      <div class="col-12">
        <div class="header_content margin-bottom-10 custom_border">
          <div class="text-center">
            <section class="mw-100 text-center margin-rl-auto padding-30">
              <h1>Customer Care</h1>
            </section>
          </div>
        </div>
      </div>

      <div class="col-12 mw-80 margin-auto">
        <div class="body_library_info margin-bottom-40">
          <section class="mw-100 body_library_info">
            <h2 class="body_library_info__section__h3">
              <div [innerHTML]="customerCareDetails?.customerCareHeaderHtml"></div>
            </h2>
          </section>

          <section class="body_library_info__content mw-100 margin-auto text-center">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-4">
                <ng-container *ngIf="customerCareDetails?.isCustomerPortal">
                  <div class="group_icon margin-bottom-40">
                    <i class="fa fa-users fa-2x" aria-hidden="true"></i>
                  </div>
                  <div class="group_text">
                    <p class="text-center margin-bottom-40">
                      <span class="three-row-ellipsis">{{
                        customerCareDetails?.customerPortalText
                      }}</span>
                    </p>
                    <p class="text-center margin-bottom-40">
                      <span style="color: #0000ff">
                        <a [href]="customerCareDetails?.customerPortalLink">
                          <span style="text-decoration: underline" class="three-row-ellipsis">
                            {{ customerCareDetails?.customerPortalLinkLabel }}
                          </span>
                        </a>
                      </span>
                    </p>
                  </div>
                </ng-container>
              </div>
              <div class="col-12 col-sm-12 col-md-4">
                <div class="contact_icon margin-bottom-40">
                  <i class="fa fa-phone fa-2x" aria-hidden="true"></i>
                </div>
                <div class="contact_text text-center">
                  <p class="margin-bottom-40">
                    <span class="three-row-ellipsis">{{ customerCareDetails?.timingsText }}</span>
                  </p>
                  <p class="margin-bottom-40">
                    <span class="three-row-ellipsis">{{
                      customerCareDetails?.phoneNumber | modifyPhoneNumber
                    }}</span>
                  </p>
                  <p class="margin-bottom-40">
                    <a [href]="'mailto: ' + customerCareDetails?.emailAddress"
                      ><span style="text-decoration: underline" class="three-row-ellipsis">{{
                        customerCareDetails?.emailAddressText
                      }}</span></a
                    >
                  </p>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-4">
                <ng-container *ngIf="customerCareDetails?.isCustomerSurvey">
                  <div class="support_icon margin-bottom-40">
                    <i class="fa fa-thumbs-up fa-2x" aria-hidden="true"></i>
                  </div>
                  <div class="support_text text-center">
                    <p class="margin-bottom-40">
                      <span class="three-row-ellipsis">{{
                        customerCareDetails?.customerSurveyText
                      }}</span>
                    </p>
                    <p class="margin-bottom-40">
                      <a
                        [href]="customerCareDetails?.customerSurveyLink"
                        target="_Blank"
                        rel="noopener noreferrer"
                      >
                        <span style="text-decoration: underline" class="three-row-ellipsis">{{
                          customerCareDetails?.customerSurveyLinkLabel
                        }}</span>
                      </a>
                    </p>
                  </div>
                </ng-container>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="col-12 body_enquiry_form mw-80 margin-auto" *ngIf="customerCareForm">
        <form (ngSubmit)="submitCustomerCareForm()" [formGroup]="customerCareForm" novalidate>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-4">
                    <label for="name" class="control-label margin-0">Name:</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" id="name" class="form-control" formControlName="name" />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-sm-4">
                    <label for="phone" class="control-label margin-0">Phone:</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" id="phone" class="form-control" formControlName="phone" />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-sm-4">
                    <label for="libraryCode" class="control-label margin-0">Library Code:</label>
                  </div>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      id="libraryCode"
                      class="form-control"
                      formControlName="libraryCode"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-sm-4">
                    <label for="browserName" class="control-label margin-0 text-start"
                      >Browser Name:</label
                    >
                  </div>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      id="browserName"
                      class="form-control"
                      formControlName="browserName"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-4">
                    <label for="libraryName" class="control-label margin-0">Library Name:</label>
                  </div>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      id="libraryName"
                      class="form-control"
                      formControlName="libraryName"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-sm-4">
                    <label for="email" class="control-label margin-0">Email Address:</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" id="email" class="form-control" formControlName="email" />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-sm-4">
                    <label for="productName" class="control-label margin-0">Product:</label>
                  </div>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      id="productName"
                      class="form-control"
                      formControlName="productName"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-sm-4">
                    <label for="problemSubject" class="control-label margin-0 text-start"
                      >Subject of Problem:</label
                    >
                  </div>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      id="problemSubject"
                      class="form-control"
                      formControlName="problemSubject"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row body_enquiry_form__detailed_info">
            <div class="col-12 col-sm-12" style="margin-top: 20px">
              <div class="form-group">
                <label for="detailedInformation" class="control-label float-start"
                  >{{ detailedInforText }}:</label
                >
                <textarea
                  rows="6"
                  id="detailedInformation"
                  class="form-control"
                  formControlName="detailedInformation"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-12 mw-70 margin-auto">
              <div class="form-group text-end">
                <button
                  role="button"
                  aria-label="Submit"
                  type="submit"
                  class="btn btn-primary margin-right-10"
                  [disabled]="!customerCareForm.valid"
                >
                  Submit
                </button>
                <button
                  role="button"
                  aria-label="Submit"
                  type="button"
                  class="btn btn-primary"
                  (click)="cancel()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</main>
